import PropTypes from 'prop-types';
import React from 'react';

const InputLabel = ({
	name,
	className = 'stamp-label-one medium5',
	style = { marginBottom: '10px' },
	asteriskColor = 'red',
	notRequired = false
}) => (
	<p className={className} style={style}>
		{name}
		{!notRequired && <span style={{ color: asteriskColor }}> *</span>}
	</p>
);

export default InputLabel;

InputLabel.propTypes = {
	name: PropTypes.any,
	className: PropTypes.any,
	style: PropTypes.any,
	asteriskColor: PropTypes.any,
	notRequired: PropTypes.any
};
